export default __webpack_public_path__ + "static/TSD_Tagger_Graphs-2-88ebcc251d4cafe6a099f7d590defc6b.png";